import React from 'react';
import { getUrgencyColor, getUrgencyIcon } from '../../constants/statusConstants';
import styles from './UrgencyBadge.module.scss';

const UrgencyBadge = React.memo(({ urgency, showIcon = true }) => (
  <span className={`badge badge-${getUrgencyColor(urgency)} ${styles.badge}`}>
    {showIcon && `${getUrgencyIcon(urgency)} `}
    {urgency?.toUpperCase()}
  </span>
));

UrgencyBadge.displayName = 'UrgencyBadge';

export default UrgencyBadge;
